import { Card, Col, Image, Row } from 'antd';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import TranslateText from 'components/hoc/TranslateText';

import next from 'styles/images/next.svg';

import AnchorComponent from './AnchorComponent';

interface IContentCard {
    title?: string;
    onButtonclick?: () => void;
    small?: boolean;
    large?: boolean;
    mainPageStyle?: boolean;
    disabled?: boolean;
    id?: string;
    children?: React.ReactNode;
}

const ContentCard: React.FC<IContentCard> = ({
    title,
    onButtonclick,
    small,
    large,
    mainPageStyle,
    disabled,
    id,
    children
}) => {
    const extraButton = () => {
        return (
            <AnchorComponent
                onClick={onButtonclick}
                style={
                    !title
                        ? {
                              flexGrow: 1,
                              display: 'flex',
                              justifyContent: 'flex-end'
                          }
                        : {}
                }
            >
                <ButtonComponent
                    icon={<Image alt="next icon" src={next} preview={false} height="20px" width="10px" />}
                    buttontext=""
                    type="text"
                    id={id}
                    style={
                        !title
                            ? {
                                  marginTop: 4,
                                  position: 'relative',
                                  right: -14
                              }
                            : {
                                  marginTop: '0.9em'
                              }
                    }
                />
            </AnchorComponent>
        );
    };

    return (
        <Col xs={24} sm={24} md={12} lg={12} xl={small ? 6 : large ? 12 : 8} className="dashboard-card-col-card">
            {onButtonclick ? (
                <AnchorComponent
                    onClick={() => (disabled ? () => {} : onButtonclick())}
                    className={disabled ? 'hover-border-disabled' : 'hover-border'}
                >
                    <Card
                        title={
                            title ? (
                                mainPageStyle ? (
                                    <h4
                                        style={{
                                            marginTop: 8,
                                            marginBottom: 4,
                                            fontWeight: 700,
                                            fontSize: 20
                                        }}
                                    >
                                        {title}
                                    </h4>
                                ) : (
                                    <TranslateText>{title}</TranslateText>
                                )
                            ) : (
                                ''
                            )
                        }
                        extra={title && !disabled && extraButton()}
                        className="dash-card"
                        bodyStyle={
                            !title
                                ? {
                                      height: '100%',
                                      display: 'flex',
                                      padding: small ? 16 : 24
                                  }
                                : {}
                        }
                        style={
                            !title
                                ? {
                                      padding: 0
                                  }
                                : {}
                        }
                    >
                        <Row
                            style={
                                !title
                                    ? {
                                          width: '100%',
                                          flexFlow: 'nowrap',
                                          alignItems: 'center'
                                          // justifyContent: 'center'
                                      }
                                    : {}
                            }
                        >
                            {children}
                            {!title && extraButton()}
                        </Row>
                    </Card>
                </AnchorComponent>
            ) : (
                <Card
                    title={title ? <TranslateText>{title}</TranslateText> : ''}
                    extra={title && onButtonclick && extraButton()}
                    className="dash-card"
                    bodyStyle={
                        !title
                            ? {
                                  height: '100%',
                                  display: 'flex',
                                  padding: small ? 16 : 24
                              }
                            : {}
                    }
                    style={
                        !title
                            ? {
                                  padding: 0
                              }
                            : {}
                    }
                >
                    <Row
                        style={
                            !title
                                ? {
                                      width: '100%',
                                      flexFlow: 'nowrap',
                                      alignItems: 'center'
                                      // justifyContent: 'center'
                                  }
                                : {}
                        }
                    >
                        {children}
                        {!title && onButtonclick && extraButton()}
                    </Row>
                </Card>
            )}
        </Col>
    );
};

export default ContentCard;
